export default __webpack_public_path__ + "static/media/vodafone-bold.7e7a152e.woff";